
export const users = function(orgId) {

  return [{
    "id": 101,
    "orgId": orgId,
    "status": "ENABLED",
    "name": "Bot",
    "alias": "Bot",
    "email": "bot-15860@drift.com",
    "phone": null,
    "locale": null,
    "timeZone": null,
    "avatarUrl": "",
    "verified": false,
    "bot": true,
    "createdAt": 1516636600606,
    "externalId": "",
    "slackUserId": null,
    "role": "MEMBER",
    "gates": null,
    "scopes": [
      "org_admin",
      "member"
    ],
    "avatars": {
      "image200": null,
      "squareCropImage200": null,
      "faceImage470": null,
      "faceImage940": null,
      "faceImage1880": null
    },
    "availability": "AVAILABLE",
    "type": "USER",
    "graphType": "TeamMember"
  },
  ]
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/demodata.js